import { render, staticRenderFns } from "./member.vue?vue&type=template&id=5b511382&scoped=true&"
import script from "./member.vue?vue&type=script&lang=js&"
export * from "./member.vue?vue&type=script&lang=js&"
import style0 from "./member.vue?vue&type=style&index=0&id=5b511382&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b511382",
  null
  
)

export default component.exports